export default {
  '@keyframes sharingCardIn': {
    from: { opacity: 0, transform: 'translateY(-12px)' },
    to: { opacity: 1, transform: 'translateY(0)' }
  },
  root: { display: 'flex', flexDirection: 'column', alignItems: 'center' },
  sectionContainer: {
    margin: '10px 0 20px 0'
  },
  rowContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  sharingCard: {
    justifyContent: 'space-between',
    height: '270px',
    alignItems: 'baseline',
    paddingTop: '20px',
    animation: '$sharingCardIn 0.25s ease-out'
  },
  cardInfoContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%'
  },
  cardInfo: {
    display: 'flex',
    fontSize: '12px',
    fontStyle: 'italic',
    maxWidth: '400px',
    padding: '10px'
  },
  starIcon: { fontSize: '8px', paddingBottom: '5px' },
  simCardContainer: { height: '180px', width: '500px' },
  footer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    borderTop: '1px solid #EBEDF2',
    padding: '10px',
    '& button': {
      margin: '10px'
    }
  },
  autoCreatedInfo: {
    padding: '8px 10px',
    fontSize: '12px',
    color: '#646c9a',
    fontStyle: 'italic',
    width: '100%'
  },
  pricesContainer: {
    fontSize: '12px',
    paddingLeft: '30px'
  },
  hidden: { visibility: 'hidden' },
  dataSharingTabsContainer: { display: 'flex', alignItems: 'center' },
  dataSharingTabs: { minHeight: '36px', marginBottom: '10px' },
  dataSharingTab: { minHeight: '36px', minWidth: '90px' }
};

export const CUSTOM_STYLES = {
  notes: {
    root: { width: '450px' },
    textfield: { width: '280px' },
    label: { width: '70px' }
  },
  confirm: {
    root: { width: '450px' },
    textfield: { width: '205px' },
    label: { width: '145px' }
  },
  simCardCheckbox: {
    root: { width: '400px', margin: '0 30px 0 0' },
    label: {
      width: '250px'
    }
  },
  checkbox: {
    root: {
      width: '400px',
      display: 'flex',
      alignItems: 'flex-start',
      paddingLeft: '30px'
    },
    label: {
      width: '135px',
      marginLeft: '10px'
    }
  },
  datePicker: {
    root: { width: '445px' },
    label: { width: '145px' },
    MuiOutlinedInputRootWidth: '205px'
  }
};
